import { Directive, inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';

@Directive({
  selector: '[appIsRiskManager]',
})
export class IsRiskManagerDirective implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly templateRef = inject(TemplateRef<HTMLElement>);
  private readonly viewContainer = inject(ViewContainerRef);

  ngOnInit(): void {
    if (this.authService.isRiskManager()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
